import { _get } from './apiClient'

const URL_BASE_CONFIGURATIONS = "configurations"

export function fetchDeviceConfiguration () {
  const url = `${URL_BASE_CONFIGURATIONS}/device/`
  return _get(url)
}
